module.exports = __webpack_public_path__ + "img/banner4.9f88a237.jpg";